<div class="flex-container gap-8" style="height: 100%">
  <vl-widget-title [text]="'dashboard_ui.commandes_fournisseurs' | trans"
                   [accent]="totalGlobal() > 0 ? (totalGlobal() | number:'1.0-0':'fr-FR') : null"
                   [widget]="widget()"
                   [draggable]="true">
    <ng-content class="drag-handler" select='.drag-handler'></ng-content>
  </vl-widget-title>

  <!-- Chips filtres -->
  <div class="flex-row gap-8 p-4 border-box shrink-0 wrap">
    <vl-chips [bubble]="countEnvoi()"
              [contentHeight]="true"
              size="small"
              [state]="subType() === widgetSubType.COMMANDE_FOURNISSEUR_EN_ATTENTE_ENVOI ? 'active' : 'enabled'"
              (action)="selectTab(widgetSubType.COMMANDE_FOURNISSEUR_EN_ATTENTE_ENVOI)">
      {{ 'dashboard_ui.cf_envoi' | trans }}
    </vl-chips>
    <vl-chips [bubble]="countConfirmation()"
              [contentHeight]="true"
              size="small"
              [state]="subType() === widgetSubType.COMMANDE_FOURNISSEUR_EN_ATTENTE_CONFIRMATION ? 'active' : 'enabled'"
              (action)="selectTab(widgetSubType.COMMANDE_FOURNISSEUR_EN_ATTENTE_CONFIRMATION)">
      {{ 'dashboard_ui.cf_confirmation' | trans }}
    </vl-chips>
    <vl-chips [bubble]="countLivraison()"
              [contentHeight]="true"
              size="small"
              [state]="subType() === widgetSubType.COMMANDE_FOURNISSEUR_EN_ATTENTE_LIVRAISON ? 'active' : 'enabled'"
              (action)="selectTab(widgetSubType.COMMANDE_FOURNISSEUR_EN_ATTENTE_LIVRAISON)">
      {{ 'dashboard_ui.cf_livraison' | trans }}
    </vl-chips>
    <vl-chips [bubble]="countPartielle()"
              [contentHeight]="true"
              size="small"
              [state]="subType() === widgetSubType.COMMANDE_FOURNISSEUR_LIVREE_PARTIELLEMENT ? 'active' : 'enabled'"
              (action)="selectTab(widgetSubType.COMMANDE_FOURNISSEUR_LIVREE_PARTIELLEMENT)">
      {{ 'dashboard_ui.cf_livree_partiel' | trans }}
    </vl-chips>
  </div>

  @if (metadata().loading) {
    <div class="grow overflow-hidden">
      <ngx-skeleton-loader count="5" [theme]="{'background-color': 'var(--color-on-disabled)', 'height': '52px'}"/>
    </div>
  } @else {
    @let stats = filteredStats();

    <!-- Badge retard (visible seulement s'il y en a) -->
    @if (stats.overdue > 0) {
      <div class="cf-summary flex-row align-center gap-8 shrink-0">
        <div class="cf-overdue-badge flex-row align-center gap-4">
          <mat-icon>schedule</mat-icon>
          <span class="caption bold">{{ stats.overdue }} en retard</span>
        </div>
      </div>
    }

    <!-- Liste des commandes (avec chip "Voir tout" flottant en bas-droite) -->
    <div class="cf-list-wrapper grow overflow-hidden">
    <div class="overflow-scroll h100 flex-col gap-4 fade-in">
      @for (elem of commandesFournisseur(); track elem.commande.id) {
        <div class="cf-card flex-row align-center gap-8 p-8 border-on-disabled border-box border-8 cursor-pointer"
             [class.cf-card-overdue]="elem.isOverdue"
             (click)="selectCommande(elem)">

          <div class="flex-col gap-2 grow overflow-hidden">

            <!-- Ligne 1 : tiers + numéro -->
            <div class="flex-row gap-8 align-center">
              <span class="body-2 bold on-background"
                    style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
                {{ elem.commande.tiers?.denomination ?? '—' }}
              </span>
              <span class="caption on-disabled shrink-0">{{ elem.commande.numero }}</span>
            </div>

            <!-- Ligne 2 : date prévue + retard éventuel + nb articles si dispo -->
            <div class="flex-row gap-8 align-center wrap">
              @if (elem.commande.dateLivraisonPrevue) {
                <span class="tiny on-disabled">
                  {{ 'commandeClient.delivery_planned_date' | trans }} :
                  {{ elem.commande.dateLivraisonPrevue | date : 'EEE d MMM' }}
                </span>
              }
              @if (elem.isOverdue) {
                <span class="cf-card-late-pill"
                      [matTooltip]="'Livraison prévue le ' + (elem.commande.dateLivraisonPrevue | date:'d MMM y')">
                  +{{ elem.daysLate }}j de retard
                </span>
              }
              @if (elem.nbLignes > 0) {
                <span class="tiny on-background-alt">·</span>
                <span class="tiny on-background-alt">
                  {{ elem.nbLignes }} {{ elem.nbLignes > 1 ? 'articles' : 'article' }}
                </span>
              }
            </div>
          </div>

          @if (elem.commande.etat === LIVREE_PARTIELLEMENT) {
            <span class="shrink-0"
                  (click)="$event.stopPropagation()"
                  matTooltip="Solder la commande (clore les reliquats non livrés)">
              <vl-chips state="valid"
                        size="small"
                        iconLeft="task_alt"
                        (action)="onSolder(elem)">
                Solder
              </vl-chips>
            </span>
          }

          <mat-icon class="on-accent shrink-0">arrow_forward</mat-icon>
        </div>
      } @empty {
        <div class="cf-empty flex-col align-center gap-8 p-16">
          <mat-icon class="cf-empty-icon">check_circle</mat-icon>
          <span class="caption on-background-alt">Tout est à jour sur cette étape</span>
          @if (totalGlobal() > 0) {
            <span class="tiny on-disabled">
              {{ totalGlobal() }} commande{{ totalGlobal() > 1 ? 's' : '' }} sur d'autres étapes
            </span>
          }
        </div>
      }
    </div>

      <!-- Chip flottant "Voir tout" — pattern aligné sur les autres widgets -->
      @if (totalGlobal() > 0) {
        <vl-chips class="see-all-chip"
                  state="active"
                  size="small"
                  iconRight="open_in_new"
                  (action)="goToList()"
                  matTooltip="Ouvrir le tableau de pilotage des commandes fournisseur (stats, retards, top fournisseurs, export Excel)">
          {{ 'button.see_all' | trans }}
        </vl-chips>
      }
    </div>
  }
</div>
